import React from "react";
import { Grid, Link, Typography, CardMedia, CardContent, CardActionArea, Card, } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { paths } from "frontend/src/pages/paths/index";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import PublicPlaylists from "./public-playlists.jpg";
import PrivatePlaylists from "./private-playlists.jpg";
import Timetables from "./timetables.jpg";
import TimetablesRuleset from "./timetables-ruleset.jpg";
import Devices from "./devices.jpg";
import UploadedFiles from "./uploaded.jpg";
var path = paths.business.owner;
var navigation = [
    {
        name: "Плейлисты imstream",
        url: path.playlists.index("public"),
        image: PublicPlaylists,
    },
    {
        name: "Мои плейлисты",
        url: path.playlists.index("private"),
        image: PrivatePlaylists,
    },
    {
        name: "Сетки вещания",
        url: path.timetables.index(),
        image: Timetables,
    },
    {
        name: "Программы вещания",
        url: path.programs.index(),
        image: TimetablesRuleset,
    },
    {
        name: "Устройства",
        url: path.devices.index(),
        image: Devices,
    },
    {
        name: "Загруженные файлы",
        url: path.files.index(),
        image: UploadedFiles,
    },
];
export var HomePage = function () { return (React.createElement(BusinessOwnerLayout, { breadcrumbs: false },
    React.createElement(Grid, { container: true, spacing: 3 }, navigation.map(function (_a) {
        var name = _a.name, url = _a.url, image = _a.image;
        return (React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 4, key: name },
            React.createElement(Link, { component: RouterLink, to: url, underline: "none" },
                React.createElement(Card, null,
                    React.createElement(CardActionArea, null,
                        React.createElement(CardMedia, { component: "img", alt: name, height: "270", image: image, title: name }),
                        React.createElement(CardContent, null,
                            React.createElement(Typography, { component: "h2" }, name)))))));
    })))); };
